import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

// types
import { CategoriesResponse, SalonsListPageQueryType } from '../../../../types/types'

// utils
import { PAGE_LINKS } from '../../../../utils/helper'
import { getTopLevelCategoryChangeEvent } from '../../../../utils/dataLayerEvents'
import { MyLocationContext } from '../../../../utils/myLocationProvider'
import { pushToDataLayer } from '../../../../utils/dataLayer'

// components
import ElementsSlider from '../../../../components/ElementsSlider/ElementsSlider'

// styles
import * as SC from './CategoriesNavigationStyles'

type Props = {
	categoriesData: CategoriesResponse
	query: SalonsListPageQueryType
}

// component
const CategoriesNavigation = (props: Props) => {
	const { categoriesData, query } = props
	const { locale } = useIntl()
	const { myLocation } = useContext(MyLocationContext)

	const handleCategoryButtonClick = (categoryID: string, categorySlug?: string) => {
		// push to dataLayer
		const event = getTopLevelCategoryChangeEvent({ categoryID, categorySlug })
		pushToDataLayer(event)
	}

	return (
		<SC.TopLevelCategoriesSliderWrapper>
			<ElementsSlider fading={false} gap={'24px'}>
				{categoriesData.categories.map((category) => (
					<SC.TopLevelCategoryButton
						type='button'
						href={PAGE_LINKS['/salons/services/:categorySlug'](locale, category.nameSlug ?? '', {
							...myLocation,
							...query,
							page: 1
						})}
						onClick={() => handleCategoryButtonClick(category.id, category.nameSlug)}
						key={category.id}
					>
						<SC.TopLevelCategoryImgWrapper>
							<SC.TopLevelCategoryImg src={category.image?.resizedImages.thumbnail} alt={category.name || ''} width={80} height={80} />
						</SC.TopLevelCategoryImgWrapper>
						<SC.TopLevelCategoryTitle>{category.name}</SC.TopLevelCategoryTitle>
					</SC.TopLevelCategoryButton>
				))}
			</ElementsSlider>
		</SC.TopLevelCategoriesSliderWrapper>
	)
}

export default CategoriesNavigation
